// Port of api/fuel/app/classes/model/listing/edition.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'list_edition',
	prefix: 'list_edition',
	key: 'list_edition_id',
	fields: {
		list_edition_id: Model.SCHEMA_NUMBER,
		list_id: Model.SCHEMA_NUMBER,
		list_edition_current: Model.SCHEMA_NUMBER,
		list_edition_name: Model.SCHEMA_TEXT,
		list_edition_slug: Model.SCHEMA_TEXT,
		list_edition_date: Model.SCHEMA_DATE,
		list_edition_date_generated: Model.SCHEMA_NUMBER,
		list_edition_count_games: Model.SCHEMA_NUMBER,
		list_edition_index_games: Model.SCHEMA_TEXT
	},
	methods: {
		get_indexed_games: function(limit) {
			var index = this.get_index_games() ? String(this.get_index_games()).split(',').map(Number) : []
			return limit ? index.slice(0, limit) : index
		},
		to_array: function() {
			return {
				id: this.get_id(),
				current: this.get_current(),
				date: this.get_date() || 0,
				name: this.get_name(),
				slug: this.get_slug(),
				count: {
					games: this.get_count_games() || 0
				}
			}
		}
	}
})
